// src/utils/authStorage.js

const STORAGE_KEY = "userData";
const ORG_ID_KEY = "orgId";

/**
 * Save user data (e.g., token, user info) to localStorage
 * @param {Object} data - The user data to store
 */
export const saveUserData = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    const orgId =
      data?.user?.orgId ||
      data?.user?.profile?.orgId ||
      data?.profile?.orgId ||
      data?.orgId;
    if (orgId != null) {
      saveOrgId(orgId);
    }
  } catch (error) {
    console.error("Error saving user data:", error);
  }
};

/**
 * Get saved user data from localStorage
 * @returns {Object|null} - Parsed user data or null if not found
 */
export const getUserData = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
};

/**
 * Remove user data from localStorage (logout)
 */
export const clearUserData = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    clearOrgId();
  } catch (error) {
    console.error("Error clearing user data:", error);
  }
};

export const saveOrgId = (orgId) => {
  try {
    if (orgId == null) {
      localStorage.removeItem(ORG_ID_KEY);
    } else {
      localStorage.setItem(ORG_ID_KEY, String(orgId));
    }
  } catch (error) {
    console.error("Error saving org ID:", error);
  }
};

export const getOrgId = () => {
  try {
    const value = localStorage.getItem(ORG_ID_KEY);
    if (value == null) return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  } catch (error) {
    console.error("Error reading org ID:", error);
    return null;
  }
};

export const clearOrgId = () => {
  try {
    localStorage.removeItem(ORG_ID_KEY);
  } catch (error) {
    console.error("Error clearing org ID:", error);
  }
};

/**
 * Check if user is logged in
 * @returns {boolean}
 */
export const isLoggedIn = () => {
  const user = getUserData();
  return !!user && !!user.token; // or any property you use to mark logged in
};
